import { Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

export const EktirenBadge = () => {
    const { t } = useLang();
    return (
        <section className="py-20 px-5" data-testid="ektiren-banner">
            <Reveal>
                <div className="gold-glow-hover max-w-3xl mx-auto text-center rounded-2xl border border-[#D4AF37]/30 bg-gradient-to-b from-[#14141A] to-[#0A0A0D] px-8 py-12 relative overflow-hidden grain-overlay">
                    <Sparkles size={18} className="mx-auto text-[#D4AF37] mb-4" />
                    <span className="ff-sans text-[11px] tracking-[0.4em] uppercase text-zinc-400 block">
                        {t("ektiren.label")}
                    </span>
                    <span className="ff-accent text-gold-gradient text-3xl md:text-4xl tracking-[0.12em] block my-3">
                        {t("ektiren.name")}
                    </span>
                    <span className="ff-sans text-[11px] tracking-[0.4em] uppercase text-zinc-400 block mb-5">
                        {t("ektiren.suffix")}
                    </span>
                    <p className="text-sm text-zinc-500 ff-sans font-light max-w-md mx-auto">
                        {t("ektiren.text")}
                    </p>
                </div>
            </Reveal>
        </section>
    );
};
